import { b } from './chunk-IMSWER4T.js';

var p=(o=>(o.IMPORT="import",o.EXPORT="export",o))(p||{});var m=(e=>(e.DYNAMIC_SETTINGS="dynamic_settings",e.FIELDS="fields",e.PROMPT_FIELDS="prompt_fields",e))(m||{});var t=class extends b{URL="modules";async getKeys(){return (await this._client.get(`${this.URL}/keys`)).data.data}};

export { p as a, m as b, t as c };
//# sourceMappingURL=chunk-7JRFK2S3.js.map
//# sourceMappingURL=chunk-7JRFK2S3.js.map